import { render, staticRenderFns } from "./ModalMinimumAge.vue?vue&type=template&id=cdc4b254"
import script from "./ModalMinimumAge.vue?vue&type=script&lang=js"
export * from "./ModalMinimumAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports